import { ScrollArea, ScrollBar } from "@primitives/scroll-area";

import { usePaginatedChatsFromLocalDB } from "@/indexedDB/hooks/usePaginatedChatsFromLocalDB";
import { useIntersectionObserver } from "@uidotdev/usehooks";
import { useEffect } from "react";
import ChatListEntry from "@/components/chat/left-column/menu-views/chat/ChatListEntry";
import { ChatType } from "@/server/types/chat";

type Props = {
  searchTerm: string;
  chatType?: ChatType.P2P | ChatType.GROUP;
};

export default function ChatList({ searchTerm, chatType }: Props) {
  const { isLoading, hasMore, results, loadMore } =
    usePaginatedChatsFromLocalDB({
      searchTerm,
      withHubId: false,
      chatType,
    });

  // TO DO => show load more only on bottom of list reached
  // TO DO => add scroll to bottom icon
  // TO DO => implement a smart scroll list reusable component
  // TO DO => Add virtualisation to the list

  const [ref, entry] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });

  useEffect(() => {
    if (!isLoading && hasMore && entry?.isIntersecting && results.length > 0) {
      // Load more results when the observer is triggered
      loadMore();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entry]);

  return (
    <ScrollArea className="flex flex-1 flex-col py-2">
      {results.map((result) => (
        <ChatListEntry key={result.id} chat={result} />
      ))}

      <div ref={ref} className="min-h-1 w-full">
        {isLoading && (
          <>
            <div className="flex flex-1 items-center justify-start gap-2 truncate p-2 align-middle">
              <div className="size-10 shrink-0 animate-pulse rounded-full bg-muted" />
              <div className="h-9 w-full animate-pulse rounded-sm bg-muted" />
              <div className="h-9 w-14 shrink-0 animate-pulse rounded-md bg-muted" />
            </div>
            <div className="flex flex-1 items-center justify-start gap-2 truncate p-2 align-middle">
              <div className="size-10 shrink-0 animate-pulse rounded-full bg-muted" />
              <div className="h-9 w-full animate-pulse rounded-sm bg-muted" />
              <div className="h-9 w-14 shrink-0 animate-pulse rounded-md bg-muted" />
            </div>
            <div className="flex flex-1 items-center justify-start gap-2 truncate p-2 align-middle">
              <div className="size-10 shrink-0 animate-pulse rounded-full bg-muted" />
              <div className="h-9 w-full animate-pulse rounded-sm bg-muted" />
              <div className="h-9 w-14 shrink-0 animate-pulse rounded-md bg-muted" />
            </div>
          </>
        )}
      </div>
      <ScrollBar orientation="vertical" />
    </ScrollArea>
  );
}
